import { useEffect, useState } from 'react';
import Modal from '@/components/base/Modal';
import Button from '@/components/base/Button';

interface SaveListModalProps {
  open: boolean;
  defaultName: string;
  count: number;
  onClose: () => void;
  onSave: (name: string) => void;
}

/** Small dialog that names a new saved creator list before it is stored. */
export default function SaveListModal({
  open,
  defaultName,
  count,
  onClose,
  onSave,
}: SaveListModalProps) {
  const [name, setName] = useState(defaultName);

  useEffect(() => {
    if (open) setName(defaultName);
  }, [open, defaultName]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      icon="ri-bookmark-3-line"
      title="Save creator list"
      subtitle={`${count} creator${count === 1 ? '' : 's'} will be saved and reusable later`}
      widthClassName="max-w-md"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button icon="ri-bookmark-3-line" onClick={() => onSave(name.trim())}>
            Save list
          </Button>
        </>
      }
    >
      <label
        htmlFor="saved-list-name"
        className="mb-1.5 block text-xs font-label font-medium text-foreground-700"
      >
        List name
      </label>
      <input
        id="saved-list-name"
        type="text"
        value={name}
        maxLength={60}
        autoFocus
        onChange={(event) => setName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onSave(name.trim());
          }
        }}
        placeholder="e.g. Q4 Beauty Pool — East Africa"
        className="h-10 w-full rounded-md border border-background-300 bg-background-50 px-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-400/30"
      />
    </Modal>
  );
}